import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";

export default function DoctorMessageModal({ isOpen, onClose, onSubmit, provider, careType }) {
  const [formData, setFormData] = useState({
    doctor_email: "",
    personal_message: ""
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(formData);
  };

  const handleChange = (e) => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-lg">
        <DialogHeader>
          <DialogTitle className="font-heading text-2xl text-text-primary">
            Send to Doctor/Case Manager
          </DialogTitle>
          <DialogDescription className="font-body text-text-secondary">
            Share your care plan and chosen provider with your healthcare team.
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={handleSubmit} className="space-y-4 mt-4">
          <div className="bg-accent/5 rounded-lg p-4 mb-4">
            <p className="text-sm font-body text-text-secondary mb-2">
              <span className="font-semibold">Recommended Care:</span> {careType}
            </p>
            <p className="text-sm font-body text-text-secondary">
              <span className="font-semibold">Selected Provider:</span> {provider?.name}
            </p>
          </div>
          <div>
            <Label htmlFor="doctor_email" className="font-body font-semibold text-text-primary">
              Doctor/Case Manager Email *
            </Label>
            <Input
              id="doctor_email"
              name="doctor_email"
              type="email"
              data-testid="doctor-email"
              value={formData.doctor_email}
              onChange={handleChange}
              required
              className="mt-2 h-12 font-body"
              placeholder="doctor@healthcare.com"
            />
          </div>
          <div>
            <Label htmlFor="personal_message" className="font-body font-semibold text-text-primary">
              Personal Message (Optional)
            </Label>
            <Textarea
              id="personal_message"
              name="personal_message"
              data-testid="personal-message"
              value={formData.personal_message}
              onChange={handleChange}
              className="mt-2 font-body min-h-[100px]"
              placeholder="Add any additional context or questions..."
            />
          </div>
          <div className="flex gap-3 pt-4">
            <Button
              type="button"
              variant="outline"
              onClick={onClose}
              className="flex-1 h-12 font-body font-semibold"
            >
              Cancel
            </Button>
            <Button
              type="submit"
              data-testid="send-doctor-message"
              className="flex-1 h-12 bg-primary text-white hover:bg-[#238C82] font-body font-semibold"
            >
              Send Message
            </Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
}
